var pug = require("!../../../../../../node_modules/pug-runtime/index.js");

function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (sd) {
function isActive(path) {
if (sd && sd.CURRENT_PATH) {
var exceptions, currentPath;
exceptions = ['/about'];
path = path.replace(/\/$/, ''); // Strip trailing slash
currentPath = sd.CURRENT_PATH.replace(/\/$/, ''); // Strip trailing slash
if (exceptions.indexOf(path) != -1) {
return currentPath.indexOf(path) != -1;
} else {
return path === currentPath;
}
}
};
function activeState(path) { if (sd && sd.CURRENT_PATH) return isActive(path) ? 'active' : 'inactive'; };
function activeClass(path) { if (sd && sd.CURRENT_PATH) return 'is-' + activeState(path); };
jade_mixins["tab"] = jade_interp = function(name, path){
var block = (this && this.block), attributes = (this && this.attributes) || {};
buf.push("<a" + (jade.attr("href", path, true, true)) + (jade.attr("data-state", activeState(path), true, true)) + " class=\"settings-tabs__tab js-avant-garde-tablist__tab\">" + (jade.escape(null == (jade_interp = name) ? "" : jade_interp)) + "</a>");
};
buf.push("<nav class=\"settings-tabs\">");
jade_mixins["tab"]('Saves & Follows', '/user/saves');
jade_mixins["tab"]('Auctions', '/user/auctions');
jade_mixins["tab"]('Collector Profile', '/profile/edit');
jade_mixins["tab"]('Settings', '/user/edit');
jade_mixins["tab"]('Payments', '/user/payments');
buf.push("</nav>");}.call(this,"sd" in locals_for_with?locals_for_with.sd:typeof sd!=="undefined"?sd:undefined));;return buf.join("");
};
module.exports = template;